export default __webpack_public_path__ + "static/media/check_white.b6fa1c1c.svg";